import './index.css'

// set default value in case url is not set (point to 404 url)
// not having MFESupportURL will block troubleshooting component to load
if(!window?.MFESupportURL){
    window.MFESupportURL = "/mfe-url-notfound"
}

import("./bootstrap");


